<template>
  <v-autocomplete
      v-if="question.type === 'boolean'"
      density="default"
      class="reg-normal text-primary mt-3"
      base-color="border-tertiary"
      bg-color="secondary"
      color="primary"
      :disabled="isDisabled"
      v-model="new_value"
      :items="['Yes', 'No', 'N/A']"
      :return-object="false"
      hide-details
      clearable>
    <template #label>
      <span class="sm-normal text-subtle">{{ $store.getters.translate('answer') }}<strong v-if="question.required">*</strong></span>
    </template>
  </v-autocomplete>
  <v-text-field
      v-else-if="question.type === 'text_field'"
      density="default"
      class="reg-normal text-primary mt-3"
      base-color="border-tertiary"
      bg-color="secondary"
      color="primary"
      :disabled="isDisabled"
      v-model="new_value"
      hide-details
      flat
      clearable>
    <template #label>
      <span class="sm-normal text-subtle">{{ $store.getters.translate('answer') }}<strong v-if="question.required">*</strong></span>
    </template>
  </v-text-field>
  <v-text-field
      v-else-if="question.type === 'date'"
      density="default"
      class="reg-normal text-primary mt-3"
      base-color="border-tertiary"
      bg-color="secondary"
      color="primary"
      :disabled="isDisabled"
      v-model="new_value"
      hide-details
      flat
      clearable
      v-mask="'##-##-####'"
      placeholder="dd-mm-yyyy">
    <template #label>
      <span class="sm-normal text-subtle">{{ $store.getters.translate('answer') }}<strong v-if="question.required">*</strong></span>
    </template>
  </v-text-field>
  <v-textarea
      v-else-if="question.type === 'text_area'"
      density="default"
      class="reg-normal text-primary mt-3"
      base-color="border-tertiary"
      bg-color="secondary"
      color="primary"
      :disabled="isDisabled"
      v-model="new_value"
      hide-details
      flat
      clearable>
    <template #label>
      <span class="sm-normal text-subtle">{{ $store.getters.translate('answer') }}<strong v-if="question.required">*</strong></span>
    </template>
  </v-textarea>
  <v-autocomplete
      v-else-if="question.type === 'select_single'"
      density="default"
      class="reg-normal text-primary mt-3"
      base-color="border-tertiary"
      bg-color="secondary"
      color="primary"
      :disabled="isDisabled"
      v-model="new_value"
      :items="question.available_answers"
      :return-object="false"
      hide-details
      clearable>
    <template #label>
      <span class="sm-normal text-subtle">{{ $store.getters.translate('answer') }}<strong v-if="question.required">*</strong></span>
    </template>
  </v-autocomplete>
  <v-autocomplete
      v-else-if="question.type === 'select_multiple'"
      density="default"
      class="reg-normal text-primary mt-3"
      base-color="border-tertiary"
      bg-color="secondary"
      color="primary"
      :disabled="isDisabled"
      v-model="new_value"
      :items="question.available_answers"
      :return-object="false"
      hide-details
      multiple
      clearable>
    <template #label>
      <span class="sm-normal text-subtle">{{ $store.getters.translate('answer') }}<strong v-if="question.required">*</strong></span>
    </template>
  </v-autocomplete>
  <v-row v-else-if="question.type === 'numeric_range'" class="mt-0">
    <v-col>
      <v-text-field
          density="default"
          class="reg-normal text-primary"
          base-color="border-tertiary"
          bg-color="secondary"
          color="primary"
          :disabled="isDisabled"
          :model-value="getAnswerPart(0)"
          @update:model-value="setAnswerPart(0, $event)"
          type="number"
          hide-details
          flat
          clearable>
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('from') }}<strong v-if="question.required">*</strong></span>
        </template>
      </v-text-field>
    </v-col>
    <v-col>
      <v-text-field
          density="default"
          class="reg-normal text-primary"
          base-color="border-tertiary"
          bg-color="secondary"
          color="primary"
          :disabled="isDisabled"
          :model-value="getAnswerPart(1)"
          @update:model-value="setAnswerPart(1, $event)"
          type="number"
          hide-details
          flat
          clearable>
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('to') }}<strong v-if="question.required">*</strong></span>
        </template>
      </v-text-field>
    </v-col>
  </v-row>
  <v-row v-else-if="question.type === 'numeric_with_units'" class="mt-0">
    <v-col>
      <v-text-field
          density="default"
          class="reg-normal text-primary"
          base-color="border-tertiary"
          bg-color="secondary"
          color="primary"
          :disabled="isDisabled"
          :model-value="getAnswerPart(0)"
          @update:model-value="setAnswerPart(0, $event)"
          type="number"
          hide-details
          flat
          clearable>
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('value') }}<strong v-if="question.required">*</strong></span>
        </template>
      </v-text-field>
    </v-col>
    <v-col cols="4">
      <v-autocomplete
          density="default"
          class="reg-normal text-primary"
          base-color="border-tertiary"
          bg-color="secondary"
          color="primary"
          :disabled="isDisabled"
          :model-value="getAnswerPart(1)"
          @update:model-value="setAnswerPart(1, $event)"
          :items="measurement_units"
          hide-details
          clearable>
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('unit') }}<strong v-if="question.required">*</strong></span>
        </template>
      </v-autocomplete>
    </v-col>
  </v-row>
  <v-autocomplete
      v-else-if="question.type === 'rating_scale'"
      density="default"
      class="reg-normal text-primary mt-3"
      base-color="border-tertiary"
      bg-color="secondary"
      color="primary"
      :disabled="isDisabled"
      v-model="new_value"
      :items="rating_scale"
      hide-details
      clearable>
    <template #label>
      <span class="sm-normal text-subtle">{{ $store.getters.translate('answer') }}<strong v-if="question.required">*</strong></span>
    </template>
  </v-autocomplete>
  <div v-else-if="question.type === 'stopwatch'" :key="question.id" class="mt-3" @vue:unmounted="stopStopwatch">
    <!--EVERY QUESTION HAS ITS OWN STOPWATCH, IT STOPS WHEN ITS QUESTION IS LEFT-->
    <span class="sm-normal text-subtle">{{ $store.getters.translate('time') }}<strong v-if="question.required">*</strong></span>
    <div class="chip-container align-center flex-wrap mt-1">
      <span class="text-h6 text-primary">
        <PhTimer style="vertical-align: middle; margin-right: 5px;" size="24"/>{{ getStopwatchDuration }}
      </span>
      <base-action-button v-if="stopwatch_stopped" :disabled="isDisabled" @action="startStopwatch">
        <template #prepend><PhPlay style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
        {{ $store.getters.translate("start") }}
      </base-action-button>
      <base-action-button v-else @action="stopStopwatch">
        <template #prepend><PhStop style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
        {{ $store.getters.translate("stop") }}
      </base-action-button>
      <base-action-button :delete="true" :disabled="isDisabled" @action="resetStopwatch">
        <template #prepend><PhArrowCounterClockwise style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
        {{ $store.getters.translate("reset") }}
      </base-action-button>
    </div>
  </div>
  <div v-else-if="question.type === 'signature'" class="mt-3" style="width: 400px; max-width: 100%;">
    <span class="sm-normal text-subtle">{{ $store.getters.translate('signature') }}<strong v-if="question.required">*</strong></span>
    <!--EVERY QUESTION HAS ITS OWN CANVAS, IT GETS A SIGNATURE PAD WHEN IT APPEARS-->
    <canvas
        ref="signature_canvas"
        :key="question.id"
        class="border-sm rounded-lg bg-secondary mt-1"
        style="display: block; width: 100%; aspect-ratio: 5 / 2;"
        :style="isDisabled ? 'pointer-events: none; opacity: var(--v-disabled-opacity);' : ''"
        @vue:mounted="initSignaturePad"
        @vue:unmounted="removeSignaturePad"/>
    <base-action-button class="mt-3" :disabled="isDisabled" :width="'100%'" @action="clearSignature">
      <template #prepend><PhEraser style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
      {{ $store.getters.translate("clear") }}
    </base-action-button>
  </div>
</template>

<script>

import helpFunctions from "../../plugins/helpFunctions";
import BaseActionButton from "./BaseActionButton";
import {PhArrowCounterClockwise, PhEraser, PhPlay, PhStop, PhTimer} from "@phosphor-icons/vue";
import SignaturePad from "signature_pad";

export default {
  components: {PhEraser, PhArrowCounterClockwise, PhStop, PhPlay, PhTimer, BaseActionButton},
  props: ["modelValue", "question", "isDisabled"],
  //WITHOUT DECLARING IT @change FALLS THROUGH TO THE ROOT FIELD AS A NATIVE LISTENER AND ALSO CATCHES THE NATIVE change EVENT OF THE INPUT (THE ANSWER BECOMES [object Event])
  emits: ["change"],
  data() {
    return {
      measurement_units: ["ohm", "m²", "m³", "Pa", "kPa", "lux", "°C", "A", "V"],
      rating_scale: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      stopwatch_stopped: true,
      stopwatch_timer: null,
      signature_pad: null,
      //THE VALUE IS NEEDED BEFORE MOUNTED: THE CANVAS DRAWS THE SAVED SIGNATURE IN ITS OWN @vue:mounted, WHICH RUNS EARLIER THAN mounted() OF THIS COMPONENT
      new_value: this.modelValue,
    };
  },
  methods: {
    //NUMERIC RANGE AND NUMERIC WITH UNITS ARE STORED IN ONE ANSWER, EVERY FIELD EDITS ITS OWN PART OF IT
    //NUMERIC RANGE IS STORED AS "10 - 20" AND NUMERIC WITH UNITS AS "10 kPa", SO THE REPORT SHOWS THEM AS IS.
    //THE FILLING FORMS SPLIT THE ANSWER BACK INTO SEPARATE FIELDS
    getAnswerPart(index) {
      if (!this.new_value) {
        return null;
      }
      else {
        return String(this.new_value).split(helpFunctions.answer_separators[this.question.type])[index] || null;
      }
    },
    setAnswerPart(index, value) {
      let parts = this.new_value ? String(this.new_value).split(helpFunctions.answer_separators[this.question.type]) : ["", ""];
      parts[index] = value ?? "";
      this.new_value = parts.every(part => !part) ? null : parts.join(helpFunctions.answer_separators[this.question.type]);
    },
    //THE STOPWATCH COUNTS THE SECONDS IN THE ANSWER ITSELF, START AFTER STOP CONTINUES THE MEASUREMENT
    startStopwatch() {
      this.new_value = this.new_value || 0;
      this.stopwatch_stopped = false;
      this.stopwatch_timer = setInterval(() => this.new_value++, 1000);
    },
    stopStopwatch() {
      clearInterval(this.stopwatch_timer);
      this.stopwatch_stopped = true;
    },
    resetStopwatch() {
      this.stopStopwatch();
      this.new_value = null;
    },
    //THE SIGNATURE IS STORED IN THE ANSWER AS A BASE64 PNG AFTER EVERY LINE, A SAVED SIGNATURE IS DRAWN BACK ON THE CANVAS
    initSignaturePad() {
      //SCALE CANVAS FOR RETINA SCREENS, OTHERWISE SIGNATURE IS BLURRY
      let canvas = this.$refs.signature_canvas;
      let ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      canvas.getContext("2d").scale(ratio, ratio);
      this.signature_pad = new SignaturePad(canvas);
      this.signature_pad.addEventListener("endStroke", () => {
        this.new_value = this.signature_pad.toDataURL();
      });
      if(this.new_value) {
        this.signature_pad.fromDataURL(this.new_value);
      }
      window.addEventListener("resize", this.resizeSignaturePad);
    },
    //A TURNED TABLET GIVES THE CANVAS ANOTHER WIDTH, WITHOUT A NEW SCALE THE LINE IS DRAWN AWAY FROM THE PEN
    resizeSignaturePad() {
      let canvas = this.$refs.signature_canvas;
      if(canvas.width !== Math.floor(canvas.offsetWidth * Math.max(window.devicePixelRatio || 1, 1))) {
        this.signature_pad.off();
        this.initSignaturePad();
      }
    },
    removeSignaturePad() {
      window.removeEventListener("resize", this.resizeSignaturePad);
      this.signature_pad.off();
    },
    clearSignature() {
      this.signature_pad.clear();
      this.new_value = null;
    },
  },
  computed: {
    getStopwatchDuration() {
      return helpFunctions.getDuration(this.new_value || 0);
    },
  },
  watch: {
    new_value: {
      handler() {
        this.$emit('change', this.new_value);
      },
      deep: true
    },
    modelValue: {
      handler() {
        this.new_value = this.modelValue;
      },
      deep: true
    },
  },
};
</script>

<style scoped>
.chip-container {
  display: flex;
  gap: 8px;
}
</style>